import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useThemeContext } from 'providers/ThemeProvider';

const LoadingOverlay: FC = () => {
  const { createSxStyles } = useThemeContext();
  const { progress } = createSxStyles({
    progress: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
    },
  });

  return (
    <Box>
      <CircularProgress sx={progress} />
    </Box>
  );
};

export default LoadingOverlay;
